import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HashLocationStrategy, LocationStrategy, registerLocaleData} from '@angular/common';
import {AppRoutingModule} from './app-routing.module';


import {AppComponent} from './app.component';
import {AppConfigComponent} from './app.config.component';
import {MenuService} from './menu/app.menu.service';

import { AppCodeModule } from './code/app.code.component';
import { AppMainComponent } from './main/app.main.component';
import { AppRightPanelComponent } from './panels/app.rightpanel.component';
import { AppMenuComponent } from './menu/app.menu.component';
import { AppMenuitemComponent } from './menu/app.menuitem.component';
import { AppTopBarComponent } from './topbar/app.topbar.component';
import { AppFooterComponent } from './footer/app.footer.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from '../shared/components/home/home.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { InitAngularModule } from './modules/init-angular/init-angular.module';
import { InitPrimengModule } from './modules/primeng/init-primeng.module';
import { ToastService } from './services/toast/toast.service';
import { AuthenticationService } from './login/authentication/authentication.service';
import { DialogService } from 'primeng/dynamicdialog';
import { BasicInterceptor } from './interceptors/basic.interceptor';
import { SharedModule } from '../shared/components/shared/shared.module';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import localePy from '@angular/common/locales/es';
import { LOCALE_ID } from '@angular/core';
import { SelectAppComponent } from './login/select-app/select-app.component';
import { InputDataTaxiComponent } from './login/input-data-taxi/input-data-taxi.component';
import { AgmModule } from './modules/agm/agm.module';
import { NotificationsComponent } from './notifications/notifications.component';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { HelpsModule } from '../shared/components/helps/helps.module';
import { DnsInterceptor } from './interceptors/dns.interceptor';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { PoliticaPrivacidadComponent } from './login/politica-privacidad/politica-privacidad.component';
import { CameraModule } from './modules/camera/camera.module';

registerLocaleData(localePy, 'es');



@NgModule({
    imports: [
        InitAngularModule,
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        InitPrimengModule,
        AppCodeModule,
        SharedModule,
        AngularSignaturePadModule,
        AgmModule,
        HelpsModule,
        CameraModule
    ],
    declarations: [
        AppComponent,
        AppMainComponent,
        AppRightPanelComponent,
        AppMenuComponent,
        AppMenuitemComponent,
        AppConfigComponent,
        AppTopBarComponent,
        AppFooterComponent,
        AppTopBarComponent,
        AppFooterComponent,
        LoginComponent,
        HomeComponent,
        SelectAppComponent,
        InputDataTaxiComponent,
        NotificationsComponent,
        PoliticaPrivacidadComponent
    ],
    providers: [
        {provide: LocationStrategy, useClass: HashLocationStrategy},
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BasicInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: DnsInterceptor,
            multi: true
        }, 
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true,
        },
        { provide: LOCALE_ID, useValue: "es-ES" },
        ToastService,
        MessageService,
        DialogService,
        ConfirmationService,
        MenuService,
        AuthenticationService
        
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
